/**
 * @name 前端业务配置
 * @description 存放前端相关的业务配置，如第三方服务的 Client ID 等
 */

/** Google 登录 Client ID */
export const GOOGLE_CLIENT_ID = '690028721611-ghvvq7g2mcqp03e2ugejrpb5ltqtb1h6.apps.googleusercontent.com';
